import {useState, useEffect, useRef} from 'react';
export default function Card ({title,messageSplit,count, id, onClick}){
  const [hoverRef, isHovered] = useHover();
  return (
    <div
      ref={hoverRef}
      style={{backgroundColor: isHovered?('rgb(152 131 229 / 69%)'):('#9883E5'), width:'10rem', margin:'1rem', padding:'1rem', color:'white', display:'flex', justifyContent:'space-between',  flexDirection:'column', cursor:'pointer', transition:'250ms'}}
      onClick={onClick}
      >
    <div>
      <h3>{title}</h3>
      <div style={{paddingTop:'1rem'}}>
        <p>Total messages:</p>
        <h2 style={{fontWeight:'100', padding:'1rem', textAlign:'center'}}>{count}</h2>
      </div>
    </div>
    <GenerateMessageSplitVisual messageSplit={messageSplit} count={count}/>
  </div>)
}

const GenerateMessageSplitVisual = ({messageSplit, count}) =>{
  const [open, setOpen] = useState(false);
  let width = 6;
  let divider = count/width;
  return(
    <div style={{height: open?('100%'):('5rem'), overflowY:'auto'}}>
      {Object.keys(messageSplit).sort((a,b)=>{if(messageSplit[a] > messageSplit[b]){return -1} return 1}).map(o=>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', margin:'.25rem'}}>
          <div style={{width:`${messageSplit[o]/divider}rem`, backgroundColor:'#50C9CE', height:'1.25rem'}} >
          </div>
          <div style={{fontSize:'.75rem'}}>{o}</div>
        </div>
      )}
    </div>
  )
}

function useHover() {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);

        return () => {
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseout', handleMouseOut);
        };
      }
    },
    [ref.current] // Recall only if ref changes
  );

  return [ref, value];
}
